module.exports = __webpack_public_path__ + "img/Kalsiy_D3_Gray_1280x1010.7e10450a.jpg";